export * from './autogrid-feature.js';
export type * from './crud.js';
export * from './autoform-feature.js';
export * from './autocrud-feature.js';
export { useDataProvider, useGridDataProvider, useComboBoxDataProvider } from './data-provider.js';

// @ts-expect-error: esbuild injection
// eslint-disable-next-line @typescript-eslint/no-unsafe-call
((feature, vaadinObj = (globalThis.Vaadin ??= {})) => {
  vaadinObj.registrations ??= [];
  vaadinObj.registrations.push({
    is: feature ? `@vaadin/hilla-react-crud/${feature}` : '@vaadin/hilla-react-crud',
    version: '25.2.0',
  });
})();
